import React from "react";
import CollapsibleCard from "../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../ForBrands/ui/LegendItem";
import RankChip, { MedianChip, medianText, rankText } from "../../../ForBrands/ui/RankChip";
import StackBar from "../../../ForBrands/ui/charts/StackBar";
import { CHART } from "../../../ForBrands/ui/charts/chartTokens";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { PerfTile, PhoneLegend } from "./perfPieces";

// Scoring Mix (Jayson's A3, spec B3 d): where the points come from as one
// stacked bar (2PT bm-ink, 3PT bm-orange, FT bm-orange at 40%, B18) with the
// division median under it (in the phone cards' caption type on phones),
// the three attempt rates (how often each shot is taken: a descriptive
// percentile, so its chip is passive and reads "88th pct", B5) with their
// medians, then the Scoring read. Both chips are passive, so both legend
// entries take the profile's grey legend dot (the box score's "Peer
// group"). Phones: the rates two a row with their ranks as text, as in the
// phone box score, and the legend as a plain line. `view` is
// athletePerformanceModel.scoringView().

const ScoringMixCard = ({ view, approximate = false, cardProps = {} }) => {
  const phone = usePhoneTheme();
  return (
    <CollapsibleCard title="Scoring Mix" subtitle={view.lede} {...cardProps}>
      {view.segments.length > 0 && <StackBar segments={view.segments} ariaLabel={view.ariaLabel} />}
      {view.caption && <p className={phone ? "bm-body-xs text-bm-muted" : "bm-body-s text-bm-muted"}>{view.caption}</p>}
      {view.tiles.length > 0 && (
        <div className={phone ? "grid grid-cols-2 gap-[10px]" : "grid grid-cols-3 gap-[10px]"}>
          {view.tiles.map((t) => (
            <PerfTile
              key={t.key}
              value={t.value}
              label={t.label}
              ranks={
                phone
                  ? [
                      { text: rankText(t.percentile, { kind: "descriptive" }), approximate: approximate && t.percentile !== null },
                      medianText(t.median, { unit: "pct", decimals: 0 }),
                    ]
                  : null
              }
            >
              <RankChip percentile={t.percentile} kind="descriptive" approximate={approximate} />
              <MedianChip value={t.median} unit="pct" decimals={0} />
            </PerfTile>
          ))}
        </div>
      )}
      {phone ? (
        <PhoneLegend lines={[[view.rankLegend, view.hasMedians && "Division median"].filter(Boolean).join(" · ")]} />
      ) : (
        <LegendRow
          label="Scoring Mix legend"
          items={[
            view.rankLegend && { key: "rank", swatch: "dot", color: CHART.muted, label: view.rankLegend },
            view.hasMedians && { key: "median", swatch: "dot", color: CHART.muted, label: "Division median" },
          ]}
        />
      )}
      <p className="bm-body-s text-bm-muted">{view.note}</p>
      <InsightList insights={view.insights} variant="read" label="Scoring read" />
    </CollapsibleCard>
  );
};

export default ScoringMixCard;
